import type { StatusT } from "@/app/types/status";

/**
 * Format status value to German display text
 */
export function formatStatus(status: StatusT | null | undefined): string {
  switch (status) {
    case "published":
      return "Veröffentlicht";
    case "draft":
      return "Entwurf";
    case "archived":
      return "Archiviert";
    default:
      return "Entwurf";
  }
}

/**
 * Get status color class for styling
 */
export function getStatusColorClass(
  status: StatusT | null | undefined
): string {
  switch (status) {
    case "published":
      return "border border-emerald-200 bg-emerald-100 text-emerald-800";
    case "draft":
      return "border border-[var(--c-border-strong)] bg-[var(--c-card)] text-[var(--c-text-soft)]";
    case "archived":
      return "text-gray-600 bg-gray-50";
    default:
      return "border border-[var(--c-border-strong)] bg-[var(--c-card)] text-[var(--c-text-soft)]";
  }
}
